import type { Room } from "livekit-client";
let activeRoom: Room | null = null;
export function attachAvatarVoice(room: Room) {
  activeRoom = room;
  return () => {
    if (activeRoom === room) activeRoom = null;
  };
}
/** LiveKit publishes energy levels; no extra microphone capture or audio upload. */
export function avatarVoiceLevel(remoteName?: string): number {
  const participant = remoteName
    ? activeRoom?.remoteParticipants.get(remoteName)
    : activeRoom?.localParticipant;
  if (!participant?.isMicrophoneEnabled || !participant.isSpeaking) return 0;
  const level = participant.audioLevel;
  return Number.isFinite(level) ? Math.max(0, Math.min(1, level)) : 0;
}

/**
 * Speech energy for a remote player by Supabase user id. LiveKit identities are
 * `<userId>:<suffix>` (supabase/functions/livekit-token), one per connection.
 */
export function avatarVoiceLevelForUser(userId?: string | null): number {
  if (!userId || !activeRoom) return 0;
  for (const p of activeRoom.remoteParticipants.values()) {
    const id = p.identity || '';
    if (id === userId || id.startsWith(`${userId}:`)) {
      if (!p.isMicrophoneEnabled || !p.isSpeaking) continue;
      const level = p.audioLevel;
      if (Number.isFinite(level) && level > 0) return Math.max(0, Math.min(1, level));
    }
  }
  return 0;
}
